import React from "react";
import { useDraggable, useDroppable } from "snapdrag";
import ExerciseItem from "./ExercisesItem";

const ExerciseItemDraggable = ({
  item,
  index,
  kind,
  onDelete,
  onEdit,
  onChangeStatus,
}) => {
  const { draggable, isDragging } = useDraggable({
    kind,
    data: { id: item._id, index, item },
    move: true,
  });

  return draggable(
    <div
      className="border p-2 bg-white rounded-md"
      style={{ opacity: isDragging ? 0.2 : 1 }}
    >
      <ExerciseItem
        item={item}
        onEdit={onEdit}
        onDelete={onDelete}
        onChangeStatus={onChangeStatus}
      />
    </div>
  );
};

const ExerciseCategory = ({
  category,
  setExercises,
  deleteExercise,
  onEditExercise,
  updateExerciseAvailability,
}) => {
  const kind = `EXERCISE_${category._id}`;

  const { droppable } = useDroppable({
    accepts: kind,
    onDrop: ({ data, over }) => {
      if (!over) return;

      const sourceId = data.id;
      const newList = [...category.exercises];

      // find moving item
      const movingIndex = newList.findIndex(
        (m) => String(m._id) === String(sourceId)
      );
      if (movingIndex === -1) return;

      const [moving] = newList.splice(movingIndex, 1);

      // over.key is the key of the item we dropped on
      const targetIndex = newList.findIndex(
        (m) => String(m._id) === String(over.key)
      );

      // if no target, append to end
      if (targetIndex === -1) {
        newList.push(moving);
      } else {
        newList.splice(targetIndex, 0, moving);
      }

      console.log("Dragged:", sourceId, "Dropped at index:", targetIndex);

      // update state
      setExercises((prev) =>
        prev.map((c) =>
          String(c._id) === String(category._id)
            ? { ...c, exercises: newList }
            : c
        )
      );

      // TODO: API call
      // axios.post("/api/exercises/reorder", {
      //   categoryId: category._id,
      //   orderedIds: newList.map((e) => e._id),
      // });
    },
  });

  return (
    <div className="mt-8">
      <h4 className="font-medium text-lg">{category?.name}</h4>
      <p className="font-light text-base mb-4">
        {category.exercises?.length ?? 0} Exercises
      </p>

      {droppable(
        <div className="grid grid-cols-5 gap-2">
          {category?.exercises?.map((exercise, index) => (
            <ExerciseItemDraggable
              key={exercise._id}
              item={exercise}
              index={index}
              kind={kind}
              onDelete={deleteExercise}
              onEdit={onEditExercise}
              onChangeStatus={updateExerciseAvailability}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ExerciseCategory;
